/* Delegated listeners also work after Shopify theme-editor section reloads. */
document.addEventListener('click', (event) => {
  const link = event.target.closest('.mobile-menu a');
  if (link) link.closest('details').removeAttribute('open');
  document.querySelectorAll('.nav-dropdown[open], .mobile-menu[open]').forEach((menu) => {
    if (!menu.contains(event.target)) menu.removeAttribute('open');
  });
  const printButton = event.target.closest('[data-print]');
  if (printButton) window.print();
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.mobile-menu[open], .nav-dropdown[open], .filter-group[open]').forEach((menu) => {
    menu.removeAttribute('open');
    menu.querySelector('summary')?.focus();
  });
});
document.addEventListener('change', (event) => {
  if (!event.target.matches('[data-variant-select]')) return;
  const form = event.target.closest('form');
  const option = event.target.selectedOptions[0];
  const section = form.closest('[data-product]');
  const button = form.querySelector('[type="submit"]');
  button.disabled = option.dataset.available !== 'true';
  button.textContent = button.disabled ? form.dataset.soldOut : form.dataset.addLabel;
  section.querySelector('[data-product-price]').textContent = option.dataset.price;
  const compare = section.querySelector('[data-compare-price]');
  compare.textContent = option.dataset.compare || '';
  compare.hidden = !option.dataset.compare;
  const image = section.querySelector('[data-main-image]');
  if (image && option.dataset.image) {
    image.src = option.dataset.image;
    image.removeAttribute('srcset');
  }
  const quantity = form.querySelector('[name="quantity"]');
  quantity.min = option.dataset.min || '1';
  quantity.step = option.dataset.step || '1';
  quantity.value = quantity.min;
  if (option.dataset.max) quantity.max = option.dataset.max;
  else quantity.removeAttribute('max');
  const nextUrl = new URL(window.location.href);
  nextUrl.searchParams.set('variant', option.value);
  window.history.replaceState({}, '', nextUrl);
});

(() => {
  const config = JSON.parse(document.getElementById('SoapInquiryConfig')?.textContent || '{}');
  const key = 'soap-inquiry-v1';
  let items = [];
  const safeUrl = (value) => {
    if (!value) return '';
    try { const url = new URL(value, location.origin); return ['http:', 'https:'].includes(url.protocol) ? url.href : ''; } catch { return ''; }
  };
  try { const saved = JSON.parse(localStorage.getItem(key) || '[]'); items = Array.isArray(saved) ? saved.filter(x => x && typeof x.id === 'string' && typeof x.title === 'string').slice(0,50) : []; } catch { /* Storage is optional. */ }
  const fromElement = (element) => ({
    id: String(element.dataset.productId || ''),
    title: element.dataset.productTitle || '',
    url: safeUrl(element.dataset.productUrl || ''),
    image: safeUrl(element.dataset.productImage || '') ,
    tile: Number(element.dataset.productTile || 10)
  });
  const current = () => {
    const el = document.querySelector('[data-current-product]');
    if (!el) return null;
    const item = fromElement(el);
    item.packaging = el.querySelector('[data-product-packaging]:checked')?.value || '';
    item.weight = el.querySelector('[data-product-weight]')?.value || '';
    item.quantity = el.querySelector('[data-product-quantity]')?.value || '';
    return item;
  };
  const effective = () => {
    const product = current();
    return product ? [product] : items;
  };
  const save = () => { try { localStorage.setItem(key, JSON.stringify(items)); } catch { /* Retain the in-memory selection. */ } };
  const persistCurrent = () => {
    const product = current();
    if (!product?.id) return;
    const index = items.findIndex(x => x.id === product.id);
    if (index === -1) items.push(product); else items[index] = product;
    save();
  };
  const payload = (selected) => selected.map((item, index) => [
    (index+1) + '. ' + item.title,
    item.url,
    item.packaging ? 'Packaging: ' + item.packaging : '',
    item.weight ? 'Target weight: ' + item.weight + ' g' : '',
    item.quantity ? 'Quantity: ' + item.quantity : ''
  ].filter(Boolean).join('\n')).join('\n\n');
  const update = () => {
    document.querySelectorAll('[data-inquiry-add]').forEach(button => {
      const active = items.some(item => item.id === button.dataset.productId);
      button.setAttribute('aria-pressed', String(active));
      button.querySelector('[data-add-label]').hidden = active;
      button.querySelector('[data-added-label]').hidden = !active;
    });
    document.querySelectorAll('[data-inquiry-count]').forEach(el => el.textContent = items.length);
    document.querySelectorAll('[data-inquiry-names]').forEach(el => {
      el.dataset.emptyText ||= el.textContent;
      el.textContent = items.length ? items.map(x => x.title).join(' · ') : el.dataset.emptyText;
    });
    document.querySelectorAll('[data-inquiry-request]').forEach(el => el.disabled = items.length === 0);
    const selected = effective();
    document.querySelectorAll('[data-inquiry-payload]').forEach(el => el.value = payload(selected));
    document.querySelectorAll('[data-inquiry-selection]').forEach(container => {
      container.replaceChildren();
      if (!selected.length) { const message = document.createElement('p'); message.className = 'muted'; message.textContent = config.empty || 'No formulas selected yet.'; container.append(message); }
      selected.forEach(item => {
        const card = document.createElement('div'); card.className = 'selection-item';
        const media = document.createElement('div'); media.className = 'selection-media';
        if (item.image && safeUrl(item.image)) { const img = document.createElement('img'); img.src = safeUrl(item.image); img.alt = item.title; img.loading = 'lazy'; media.append(img); }
        else { const tile = Math.max(0,Math.min(15,Number(item.tile)||0)); const photo = document.createElement('span'); photo.className='soap-atlas'; photo.setAttribute('role','img'); photo.setAttribute('aria-label',item.title); photo.style.backgroundImage='url("'+config.atlas+'")'; photo.style.setProperty('--atlas-x', ((tile%4)*100/3)+'%'); photo.style.setProperty('--atlas-y', (Math.floor(tile/4)*100/3)+'%'); media.append(photo); }
        const heading = document.createElement('h3'); heading.textContent=item.title;
        card.append(media,heading);
        const description = document.createElement('p'); description.textContent=[item.packaging,item.weight ? item.weight+' g':'',item.quantity ? item.quantity+' pcs':''].filter(Boolean).join(' · ');card.append(description);
        if (!current()) { const remove = document.createElement('button'); remove.type='button';remove.dataset.inquiryRemove=item.id;remove.textContent=config.remove || 'Remove';remove.setAttribute('aria-label',(config.remove || 'Remove')+' '+item.title);card.append(remove); }
        container.append(card);
      });
    });
  };
  const request = (type, move = true) => {
    document.querySelectorAll('[data-inquiry-type]').forEach(el => el.value = type);
    if (move && !document.getElementById('quote')) { location.href = (window.SoapContactUrl || '/pages/contact') + '?request_type=' + encodeURIComponent(type); return; }
    if (move) { location.hash = 'quote'; document.querySelector('.inquiry-form input[autocomplete="name"]')?.focus({preventScroll:true}); }
  };
  const validOptions = () => {
    for (const input of document.querySelectorAll('[data-product-weight], [data-product-quantity]')) if (!input.reportValidity()) return false;
    return true;
  };
  document.addEventListener('click', event => {
    const arrow = event.target.closest('[data-gallery-step]');
    if (arrow) {
      const buttons = [...arrow.closest('[data-product]').querySelectorAll('[data-gallery-image]')];
      const index = Math.max(0, buttons.findIndex(button => button.getAttribute('aria-pressed') === 'true'));
      if (buttons.length) buttons[(index + Number(arrow.dataset.galleryStep) + buttons.length) % buttons.length].click();
    }
    const gallery = event.target.closest('[data-gallery-image]');
    if (gallery) {
      const image = gallery.closest('[data-product]').querySelector('[data-main-image]');
      if (image) { image.src=gallery.dataset.galleryImage;image.alt=gallery.dataset.galleryAlt;image.removeAttribute('srcset'); }
      gallery.closest('.product-thumbnails').querySelectorAll('button').forEach(el=>el.setAttribute('aria-pressed',String(el===gallery)));
    }
    const add = event.target.closest('[data-inquiry-add]');
    if (add) {
      if (add.closest('[data-current-product]') && !validOptions()) return;
      const item = add.closest('[data-current-product]') ? current() : fromElement(add);
      const index = items.findIndex(x=>x.id===item.id);
      if (index>=0) items.splice(index,1); else if(items.length<50) items.push(item);
      save();update();
      document.querySelectorAll('[data-inquiry-status]').forEach(el=>el.textContent=config.updated);
    }
    const remove = event.target.closest('[data-inquiry-remove]');
    if (remove) { items=items.filter(x=>x.id!==remove.dataset.inquiryRemove);save();update(); }
    const productRequest = event.target.closest('[data-current-request]');
    if (productRequest) {
      if(!validOptions()){event.preventDefault();return;}
      persistCurrent(); update();
      const product = current();
      document.querySelectorAll('[data-inquiry-quantity]').forEach(el=>el.value=product.quantity);
      request(productRequest.dataset.currentRequest,false);
    }
    const listRequest = event.target.closest('[data-inquiry-request]');
    if (listRequest) request(listRequest.dataset.inquiryRequest);
    const plainRequest=event.target.closest('[data-request-type]');
    if(plainRequest) request(plainRequest.dataset.requestType,false);
  });
  document.addEventListener('change',event=>{
    if(event.target.matches('[data-auto-submit]')) event.target.form?.requestSubmit();
    if(event.target.matches('[data-inquiry-quantity]') && current()) {
      document.querySelectorAll('[data-product-quantity]').forEach(el=>el.value=event.target.value);
      if(items.some(x=>x.id===current().id)) persistCurrent();
      update();
    }
    if(event.target.matches('[data-product-packaging], [data-product-weight], [data-product-quantity]')) {
      const product=current();
      if(items.some(x=>x.id===product.id)) persistCurrent();
      update();
      if(event.target.matches('[data-product-quantity]'))document.querySelectorAll('[data-inquiry-quantity]').forEach(el=>el.value=product.quantity);
    }
  });
  document.addEventListener('submit',event=>{
    if(event.target.matches('.inquiry-form')) {
      if(!validOptions()){event.preventDefault();return;}
      if(current())persistCurrent();
      event.target.querySelector('[data-inquiry-payload]').value=payload(effective());
    }
  });
  document.addEventListener('shopify:section:load',update);
  document.addEventListener('shopify:block:select',event=>{
    const details=event.target.closest('details') || event.target.querySelector('details');
    if(details) details.open=true;
  });
  window.addEventListener('storage',event=>{
    if(event.key!==key)return;
    try { const data=JSON.parse(event.newValue || '[]');items=Array.isArray(data)?data.filter(x=>x&&typeof x.id==='string'&&typeof x.title==='string').slice(0,50):[];update(); }catch{}
  });
  const product=current();
  const saved=product && items.find(x=>x.id===product.id);
  if(saved){
    document.querySelectorAll('[data-product-packaging]').forEach(el=>el.checked=el.value===saved.packaging);
    if(!document.querySelector('[data-product-packaging]:checked'))document.querySelector('[data-product-packaging]')?.click();
    document.querySelectorAll('[data-product-weight]').forEach(el=>el.value=saved.weight || '');
    document.querySelectorAll('[data-product-quantity]').forEach(el=>el.value=saved.quantity || '');
    document.querySelectorAll('[data-inquiry-quantity]').forEach(el=>el.value=saved.quantity || '');
  }
  update();
})();

 document.querySelectorAll('[data-contact-request-type]').forEach(el => { const type = new URLSearchParams(location.search).get('request_type'); el.value = type === 'Samples' ? 'Samples' : 'Quote'; });
